module.exports = __webpack_public_path__ + "img/error.447fd486.svg";